<script setup lang="ts">
import type { Url } from '@global-types/url.ts';
import { computed } from 'vue';
import { useNavbarStore } from '@stores/layout/useNavbarStore';
import Typography from '@components/Typography.vue';
import { storeToRefs } from 'pinia';

interface MenuLinkProps {
  link?: Url,
  hasPin?: boolean,
}

const { link, hasPin = false } = defineProps<MenuLinkProps>();

const navbarStore = useNavbarStore();
const { isCurrentPage } = navbarStore;
const { isPlusMenuOpen } = storeToRefs(navbarStore);

const isActive = computed<boolean>(() => (link ? isCurrentPage(link) && !isPlusMenuOpen.value : false));
</script>

<template>
  <component
    :is="link ? 'a' : 'div'"
    :class="[
      'h-11 w-[74px]',
      'flex flex-col items-center justify-center space-y-1',
      'no-underline'
    ]"
    :href="link"
  >
    <div class="relative flex shrink-0">
      <slot name="icon" :is-active="isActive" />

      <span
        v-if="hasPin"
        class="menu-link__pin"
        :class="[
          'absolute right-0 top-0',
          'rounded-full border border-white',
          'size-3',
          'bg-red',
        ]"
      />
    </div>

    <Typography
      :class="{ '!font-semibold': isActive }"
      variant="caption"
      :color="isActive ? 'blue' : 'gray-darker'"
    >
      <slot name="text" />
    </Typography>
  </component>
</template>
